// بيانات أذكار المسلم اليومية والسبحة الإلكترونية
export const ATHKAR_CATEGORIES = [
  {
    id: 'morning',
    title: 'أذكار الصباح',
    subtitle: 'حصن المسلم مع بداية كل يوم',
    icon: 'Sun',
    items: [
      {
        id: 'm1',
        text: 'أَصْبَحْنَا وَأَصْبَحَ الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ.',
        count: 1,
        reward: 'حفظ وبركة في يومك وتفويض الأمر لله.'
      },
      {
        id: 'm2',
        text: 'اللَّهُمَّ بِكَ أَصْبَحْنَا، وَبِكَ أَمْسَيْنَا، وَبِكَ نَحْيَا، وَبِكَ نَمُوتُ، وَإِلَيْكَ النُّشُورُ.',
        count: 1,
        reward: 'سنة نبوية مؤكدة في الاستفتاح.'
      },
      {
        id: 'm3',
        text: 'اللَّهُمَّ أَنْتَ رَبِّي لاَ إِلَهَ إِلاَّ أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ بِذَنْبِي فَاغْفِرْ لِي فَإِنَّهُ لاَ يَغْفِرُ الذُّنُوبَ إِلاَّ أَنْتَ.',
        count: 1,
        reward: 'سيد الاستغفار - من قاله موقناً بها فمات من يومه دخل الجنة.'
      },
      {
        id: 'm4',
        text: 'بِسْمِ اللَّهِ الَّذِي لاَ يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الأَرْضِ وَلاَ فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ.',
        count: 3,
        reward: 'لم يضره شيء حتى يمسي.'
      },
      {
        id: 'm5',
        text: 'أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ.',
        count: 3,
        reward: 'حماية وحصن من كل سوء.'
      },
      {
        id: 'm6',
        text: 'يَا حَيُّ يَا قَيُّومُ بِرَحْمَتِكَ أَسْتَغِيثُ، أَصْلِحْ لِي شَأْنِي كُلَّهُ، وَلاَ تَكِلْنِي إِلَى نَفْسِي طَرْفَةَ عَيْنٍ.',
        count: 1,
        reward: 'تفويض وسؤال صلاح الأحوال كلها.'
      },
      {
        id: 'm7',
        text: 'سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ، وَرِضَا نَفْسِهِ، وَزِنَةَ عَرْشِهِ، وَمِدَادَ كَلِمَاتِهِ.',
        count: 3,
        reward: 'تعدل أجوراً مضاعفة في الذكر.'
      }
    ]
  },
  {
    id: 'evening',
    title: 'أذكار المساء',
    subtitle: 'تحصين النفس والسكينة في المساء',
    icon: 'Sunset',
    items: [
      {
        id: 'e1',
        text: 'أَمْسَيْنَا وَأَمْسَى الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ.',
        count: 1,
        reward: 'حفظ الليل وشكر النعمة.'
      },
      {
        id: 'e2',
        text: 'اللَّهُمَّ بِكَ أَمْسَيْنَا، وَبِكَ أَصْبَحْنَا، وَبِكَ نَحْيَا، وَبِكَ نَمُوتُ، وَإِلَيْكَ الْمَصِيرُ.',
        count: 1,
        reward: 'سنة المساء المباركة.'
      },
      {
        id: 'e3',
        text: 'اللَّهُمَّ مَا أَمْسَى بِي مِنْ نِعْمَةٍ أَوْ بِأَحَدٍ مِنْ خَلْقِكَ فَمِنْكَ وَحْدَكَ لاَ شَرِيكَ لَكَ، فَلَكَ الْحَمْدُ وَلَكَ الشُّكْرُ.',
        count: 1,
        reward: 'من قالها حين يمسي أدى شكر ليلته.'
      },
      {
        id: 'e4',
        text: 'أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ.',
        count: 3,
        reward: 'لم تضره حمة ولا دابة تلك الليلة.'
      },
      {
        id: 'e5',
        text: 'اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا وَالآخِرَةِ، اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي دِينِي وَدُنْيَايَ وَأَهْلِي وَمَالِي.',
        count: 1,
        reward: 'سؤال السلامة الشاملة في الدين والبدن.'
      }
    ]
  },
  {
    id: 'after_prayer',
    title: 'أذكار بعد الصلاة',
    subtitle: 'ما يُقال بعد السلام من الفريضة',
    icon: 'Sparkles',
    items: [
      {
        id: 'p1',
        text: 'أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ. اللَّهُمَّ أَنْتَ السَّلاَمُ وَمِنْكَ السَّلاَمُ، تَبَارَكْتَ يَا ذَا الْجَلاَلِ وَالإِكْرَامِ.',
        count: 1,
        reward: 'رواه مسلم.'
      },
      {
        id: 'p2',
        text: 'لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، اللَّهُمَّ لاَ مَانِعَ لِمَا أَعْطَيْتَ، وَلاَ مُعْطِيَ لِمَا مَنَعْتَ، وَلاَ يَنْفَعُ ذَا الْجَدِّ مِنْكَ الْجَدُّ.',
        count: 1,
        reward: 'متفق عليه.'
      },
      { id: 'p3', text: 'سُبْحَانَ اللَّهِ.', count: 33, reward: 'من سبّح دبر كل صلاة ثلاثاً وثلاثين…' },
      { id: 'p4', text: 'الْحَمْدُ لِلَّهِ.', count: 33, reward: 'وحمد ثلاثاً وثلاثين…' },
      { id: 'p5', text: 'اللَّهُ أَكْبَرُ.', count: 33, reward: 'وكبّر ثلاثاً وثلاثين…' },
      {
        id: 'p6',
        text: 'لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ.',
        count: 1,
        reward: 'تمام المائة — غُفرت خطاياه وإن كانت مثل زبد البحر. رواه مسلم.'
      },
      {
        id: 'p7',
        text: 'اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ، لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ، لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ، مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ، يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ، وَلاَ يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلاَّ بِمَا شَاءَ، وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ، وَلاَ يَئُودُهُ حِفْظُهُمَا، وَهُوَ الْعَلِيُّ الْعَظِيمُ.',
        count: 1,
        reward: 'آية الكرسي — لم يمنعه من دخول الجنة إلا أن يموت. رواه النسائي.'
      },
      {
        id: 'p8',
        text: 'قراءة سورة الإخلاص والفلق والناس.',
        count: 1,
        reward: 'مرة بعد كل صلاة، وثلاثاً بعد الفجر والمغرب.'
      }
    ]
  },
  {
    id: 'sleep',
    title: 'أذكار النوم',
    subtitle: 'آيات الحفظ والراحة الإيمانية',
    icon: 'Moon',
    items: [
      {
        id: 's1',
        text: 'بِاسْمِكَ رَبِّي وَضَعْتُ جَنْبِي، وَبِكَ أَرْفَعُهُ، فَإِنْ أَمْسَكْتَ نَفْسِي فَارْحَمْهَا، وَإِنْ أَرْسَلْتَهَا فَاحْفَظْهَا بِمَا تَحْفَظُ بِهِ عِبَادَكَ الصَّالِحِينَ.',
        count: 1,
        reward: 'استيداع النفس لله قبل النوم.'
      },
      {
        id: 's2',
        text: 'اللَّهُمَّ قِنِي عَذَابَكَ يَوْمَ تَبْعَثُ عِبَادَكَ.',
        count: 3,
        reward: 'كان النبي ﷺ يضع يده اليمنى تحت خده ويقولها 3 مرات.'
      },
      {
        id: 's3',
        text: 'قراءة آية الكرسي: ﴿اللَّهُ لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ...﴾',
        count: 1,
        reward: 'لا يزال عليك من الله حافظ ولا يقربك شيطان حتى تصبح.'
      }
    ]
  },
  {
    id: 'duas',
    title: 'جوامع الدعاء والرقية',
    subtitle: 'أدعية نبوية مأثورة ومستجابة',
    icon: 'Sparkles',
    items: [
      {
        id: 'd1',
        text: 'رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ.',
        count: 3,
        reward: 'أكثر دعاء كان يدعو به النبي ﷺ.'
      },
      {
        id: 'd2',
        text: 'اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ، وَالْعَجْزِ وَالْكَسَلِ، وَالْبُخْلِ وَالْجُبْنِ، وَضَلَعِ الدَّيْنِ وَغَلَبَةِ الرِّجَالِ.',
        count: 1,
        reward: 'دعاء كشف الهموم وقضاء الديون.'
      },
      {
        id: 'd3',
        text: 'لاَ إِلَهَ إِلاَّ أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ.',
        count: 3,
        reward: 'دعاء ذي النون - لم يدعُ به رجل مسلم في شيء قط إلا استجاب الله له.'
      }
    ]
  }
];

// أذكار السبحة الإلكترونية
export const TASBEEH_PRESETS = [
  { id: 'subhanallah', title: 'سُبْحَانَ اللَّهِ', target: 33, count: 0, reward: 'شجرة تُغرس لك في الجنة' },
  { id: 'alhamdulillah', title: 'الْحَمْدُ لِلَّهِ', target: 33, count: 0, reward: 'تملأ الميزان بالخيرات' },
  { id: 'allahuakbar', title: 'اللَّهُ أَكْبَرُ', target: 34, count: 0, reward: 'أحب الكلام إلى الله' },
  { id: 'la_ilaha', title: 'لَا إِلَهَ إِلَّا اللَّهُ', target: 100, count: 0, reward: 'أفضل الذكر وخير ما قال النبيون' },
  { id: 'astaghfirullah', title: 'أَسْتَغْفِرُ اللَّهَ وَأَتُوبُ إِلَيْهِ', target: 100, count: 0, reward: 'جالب للرزق ومغفرة الذنوب وتفريج الكروب' },
  { id: 'salawat', title: 'اللَّهُمَّ صَلِّ وَسَلِّمْ عَلَى نَبِيِّنَا مُحَمَّدٍ', target: 100, count: 0, reward: 'من صلى عليّ صلاة صلى الله عليه بها عشراً' },
  { id: 'hawqalah', title: 'لَا حَوْلَ وَلَا قُوَّةَ إِلَّا بِاللَّهِ', target: 100, count: 0, reward: 'كنز من كنوز الجنة' },
  { id: 'subhan_wa_bihamdih', title: 'سُبْحَانَ اللَّهِ وَبِحَمْدِهِ ، سُبْحَانَ اللَّهِ الْعَظِيمِ', target: 100, count: 0, reward: 'كلمتان خفيفتان على اللسان ثقيلتان في الميزان' },
];

/** هل المعرّف فئة أذكار معروفة؟ — يحرس ما يأتي من الإشعارات. */
export const isAthkarCategory = (id) => ATHKAR_CATEGORIES.some((c) => c.id === id);
